export default function arrayToObject(array: any[], keyField: string): any {
  return array.reduce((obj, item) => {
    obj[item[keyField]] = item;
    return obj;
  }, {});
}
